module.exports = __webpack_public_path__ + "0849ad373057bb17da6f1f5ece8dd961.pdf";